import React from "react";
import { useTranslation } from "react-i18next";
import { Identifiable, List } from "@planzone/dto";
import { list as listMock } from "@planzone/dto";
import { useListsRetrieval, useListCreation } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";

import { Props } from "./types";
import { ListCreationForm } from "./listCreationForm";
import styles from "./styles.scss";

function flattenLists(list: Identifiable<List>): Identifiable<List>[] {
  return list.subLists.reduce(
    (lists, subList) => [...lists, ...flattenLists(subList)],
    [list],
  );
}

function ListCreation(props: Props) {
  const filter = { limit: 999999999999, start: 0 };
  const [list, setList] = React.useState<List>({
    ...listMock,
    activityKeyRank: -1,
    parentList: props.list,
  });
  const { t } = useTranslation();
  const { lists, retrieveLists } = useListsRetrieval(props.project, filter);
  const { isRequestPending, error, createList } = useListCreation();

  React.useEffect(() => {
    !!props.project.uuid && retrieveLists({ project: props.project, filter });
  }, [props.project.uuid]);

  return (
    <Modal header={t("listCreation.title")} close={props.cancel}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          !isRequestPending && createList({ project: props.project, list });
        }}
        className={styles.listCreation}
      >
        <div className={styles.main}>
          <div className={styles.form}>
            <ListCreationForm
              error={error}
              formData={list}
              lists={[lists]}
              editForm={setList}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={props.cancel}>
            {t("listCreation.cancel")}
          </Button>
          <div className={styles.button}>
            <Button
              status={isRequestPending ? "pending" : "none"}
              type="submit"
            >
              {t("listCreation.submit")}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export { ListCreation };
